module.exports = __webpack_public_path__ + "img/JCDecaux_logo.2f151070.png";